import * as React from 'react'
import { FormattedHTMLMessage } from 'react-intl'
import DoodleBackground from '../../../../components/doodle-background'

import styles from './intro.module.scss'

export default function Intro() {
  return (
    <div className={styles.root}>
      <DoodleBackground className={styles.doodles} />
      <div className={styles.outer}>
        <div className={styles.inner}>
          <p className={styles.heading}>
            <FormattedHTMLMessage
              defaultMessage="Här finns material som du kan använda till nyheter, artiklar och press- eller blogginlägg. Vid frågor är du välkommen att skicka ett mail till <a href='mailto:hej@dooer.com' target='_blank' rel='noopener noreferrer'>hej@dooer.com</a>."
              id="press.intro.heading"
            />
          </p>
        </div>
      </div>
    </div>
  )
}
